export default "__VITE_ASSET__CqNDTaFm__"